<template>
  <div class="gp-content">
    <content-nav-bar>
      <h5 class="is-size-4 has-text-centered level-item">Create Action Configuration</h5>
      <a v-on:click="submit()" class="level-item button add">
        <i class="far fa-save"></i>
        Save
      </a>
      <p v-if="validMessage" class="level-item message">{{ validMessage }}</p>
    </content-nav-bar>
    <div class="scroll-vertical">
      <action-configs-form
        :action.sync="action"
        :validMessage.sync="validMessage"
        :existing="false">
      </action-configs-form>
    </div>
  </div>
</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import ActionConfigsForm from '@/components/actions/forms/ActionConfigsForm.vue';

export default {
  name: 'CreateAction',
  components: {
    ContentNavBar,
    ActionConfigsForm,
  },
  computed: {
    computedAction() {
      return {
        name: this.action.name,
        description: this.action.description,
        logConfig: JSON.stringify(this.action.logConfig),
        alertConfig: JSON.stringify(this.action.alertConfig),
        cacheConfig: JSON.stringify(this.action.cacheConfig),
      };
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const action = await this.$store.dispatch('primary/createActionConfigs', this.computedAction);
      this.showLoader = false;
      if (action) {
        this.$router.push({ name: 'actions.index.detail', params: { id: action.id } });
      }
    },
  },
  data() {
    return {
      action: this.$typeDefs.configs.action,
      showLoader: false,
      validMessage: null,
    };
  },
};
</script>
